import { render } from "./room.vue?vue&type=template&id=5e069bb8&scoped=true"
import script from "./room.vue?vue&type=script&lang=js"
export * from "./room.vue?vue&type=script&lang=js"

import "./room.vue?vue&type=style&index=0&id=5e069bb8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e069bb8"]])

export default __exports__